<button class="button">
    {{ svg "corners-out" 44 "icon" }}
</button>
